module.exports = __webpack_public_path__ + "static/media/solution.21.553b3cd8.png";